import { faBaby as fasBaby, faPerson as fasPerson } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { TYPE_OF_PROPERTY_FOR_OTTHON_START } from "@component/Mortgage/Calculator/data";
import type { TargetPropertyAcceptableType } from "@component/Mortgage/Calculator/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonLegacy, FormDecidable, FormNumber, FormRadio } from "@shared/ui";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { MAX_AGES, MAX_CHILD_NUMBER, MIN_AGES, MIN_CHILD_NUMBER } from "../constants";
import type { FormFields } from "../types";

export interface StepFields {
	isMarried: boolean;
	womanAge: number;
	currentChildren: number;
	plannedChildren: number;
	wantsFirstHouse: boolean;
	targetPropertyAcceptableType: TargetPropertyAcceptableType;
}

export class Step2 extends AbstractStep<StepFields> {
	protected renderContent(values: FormFields): ReactNode {
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body className="d-flex flex-column">
					<FormDecidable
						label="Házasként vásárolnátok az ingatlant?"
						name="isMarried"
						disabled={disabled}
						className="mt-2"
						required
					/>
					<FormNumber
						label="Házaspár hölgy tagjának életkora"
						name="womanAge"
						validate={this.validWomanAge}
						className="mt-2"
						prepend={<FontAwesomeIcon icon={fasPerson} />}
						disabled={disabled || values.isMarried === false}
						required
					/>
					<FormNumber
						label="Meglévő gyermekek száma"
						className="mt-2"
						name="currentChildren"
						validate={this.validchildNumber}
						prepend={<FontAwesomeIcon icon={fasBaby} />}
						disabled={disabled}
						required
					/>
					<FormNumber
						label="Vállalt gyermekek száma"
						className="mt-2"
						name="plannedChildren"
						validate={this.validchildNumber}
						prepend={<FontAwesomeIcon icon={fasBaby} />}
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Első ingatlanod vásárolnád?"
						className="mt-2"
						name="wantsFirstHouse"
						disabled={disabled}
						required
					/>
					<FormRadio
						label="Milyen ingatlant vásárolnál?"
						name="targetPropertyAcceptableType"
						options={TYPE_OF_PROPERTY_FOR_OTTHON_START}
						disabled={disabled}
						variant="centered"
						inlineOptions
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center mb-1">
					<ButtonLegacy type="submit" className="mb-1 font-weight-bold" block>
						Mutasd az eredményt
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private validchildNumber(childNumber: number): string {
		if (childNumber < MIN_CHILD_NUMBER) {
			return `Nem lehet kevesebb mint ${MIN_CHILD_NUMBER}!`;
		}

		if (childNumber > MAX_CHILD_NUMBER) {
			return `Nem lehet több a gyermekek száma mint ${MAX_CHILD_NUMBER}!`;
		}
	}

	private validWomanAge(age: number): string {
		if (age < MIN_AGES) {
			return `A feleség életkora nem lehet kevesebb mint ${MIN_AGES} év!`;
		}

		if (age > MAX_AGES) {
			return `A feleség életkora nem lehet több mint ${MAX_AGES} év!`;
		}
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
